module.exports = __webpack_public_path__ + "img/Gastronomia.a1dfe9f7.png";